/**
 * @generated SignedSource<<712f1aeb68fd6b98c4bb10c07015dc3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContact_user">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_user";
};
export type PdpRespSidebarSellerInfoAndContactLazy_user$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContact_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d3950256262cebedafb92a27120cdb69";

export default node;
